import React from 'react'
import withLayout from '../../../layout/withLayout'
import SalesOrderOverview from './SalesOrderOverview'
import { lifecycle } from 'recompose'
import SalesOrderCustomer from './SalesOrderCustomer'
import SentEmailList from '../../../email/component/sent/SentEmailList'
import InvoiceList from '../../../invoice/component/list/InvoiceList'
import PaymentList from '../../../payment/component/list/PaymentList'
import StatusHistory from './StatusHistory'
import ShipmentList from '../../../logistic/component/list/ShipmentListContainer'
import CustomsInvoiceList from '../../../invoice/component/list/CustomsInvoiceList'

const SalesOrderDetail = (props) => {
    const { salesOrder, addShipment } = props

    if (!salesOrder) {
        return null
    }

    return (
        <div>
            <SalesOrderOverview {...props}/>
            <SalesOrderCustomer {...props} salesOrderCustomer={salesOrder.salesOrderCustomer}/>
            {!salesOrder.hasProcess && (<StatusHistory statusHistory={salesOrder.statusHistory}/>)}
            <SentEmailList sentEmailList={salesOrder.sentEmailList}/>
            <InvoiceList invoiceList={salesOrder.invoiceList} confirmationModalOpen={false} closeConfirmationModal={() => {
            }}/>
            <CustomsInvoiceList customsInvoiceList={salesOrder.customer.customsInvoiceList} />
            <PaymentList paymentList={salesOrder.paymentList}/>
            <ShipmentList shipmentList={salesOrder.shipmentList} salesOrder={salesOrder} addShipment={addShipment}/>
        </div>
    )
}

export default lifecycle({
    componentDidMount () {
        this.props.findSalesOrder(this.props.salesOrderId)
    },
})(withLayout(SalesOrderDetail))



// WEBPACK FOOTER //
// ./src/modules/sales-order/component/detail/SalesOrderDetail.js